class ValidationForm extends HTMLElement {
  constructor() {
    super();
    this.getSettings = this.querySelector('[type="application/json"]');
    this.passwordRequestWorkflow = this.querySelector(
      "[data-send-password-request]"
    );
    this.settings =
      this.getSettings && JSON.parse(this.getSettings.textContent);
    this.sendNotificationFlag = false;
    this.address1 = "";
    this.address2 = "";
    this.name = "";
    this.surname = "";
    this.phone = "";
    this.form = this.querySelector("form");
    this.submitButton = this.querySelector("button[type='submit']");
    this.textInputs = this.querySelectorAll('input[type="text"][required]');
    this.emailInputs = this.querySelectorAll('input[type="email"][required]');
    this.passwordInputs = this.querySelectorAll(
      'input[type="password"][required]'
    );
    this.checkboxInputs = this.querySelectorAll(
      'input[type="checkbox"][required]'
    );
    this.telInputs = this.querySelectorAll('input[type="tel"][required]');
    this.numberInputs = this.querySelectorAll('input[type="number"][required]');
    this.allRequiredInputs = this.querySelectorAll("input[required]");
    this.allInputs = this.querySelectorAll("input");
    this.clearButtons = this.querySelectorAll("[data-clear-fields]");
    this.originPass = "";
    this.confirmPass = "";

    if (this.submitButton)
      this.submitButton.addEventListener("click", (e) => this.handleSubmit(e));
    if (this.passwordRequestWorkflow)
      this.passwordRequestWorkflow.addEventListener("click", (e) =>
        this.sendPasswordRequest(e)
      );

    if (this.clearButtons.length)
      this.clearButtons.forEach((btn) =>
        btn.addEventListener("click", this.clearFields.bind(this))
      );

    this.textInputs.forEach((input) =>
      input.addEventListener("input", (e) => this.textInputsValid(e.target))
    );
    this.emailInputs.forEach((input) =>
      input.addEventListener("input", (e) => this.emailInputsValid(e.target))
    );
    this.passwordInputs.forEach((input) => {
      const span = document.createElement("span");
      span.className = "show-pass";
      input.closest(".form-element").prepend(span);
      span.addEventListener("click", () => {
        input.type === "password"
          ? (input.type = "text")
          : (input.type = "password");
        span.classList.toggle("hide");
      });
      input.addEventListener("input", (e) =>
        this.passwordInputsValid(e.target)
      );
    });
    this.checkboxInputs.forEach((input) =>
      input.addEventListener("input", (e) => this.checkboxInputsValid(e.target))
    );
    this.telInputs.forEach((input) =>
      input.addEventListener("input", (e) => this.telInputsValid(e.target))
    );
    this.numberInputs.forEach((input) =>
      input.addEventListener("input", (e) => this.numberInputsValid(e.target))
    );
  }
  async sendNotification(adminEmail, userEmail, shopUrl) {
    if (!this.settings && !this.settings.workflowUrl) return;
    await fetch(this.settings.workflowUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        adminEmail,
        userEmail,
        shopUrl,
      }),
    })
      .then((res) => {
        console.log(res);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  async sendPasswordRequest(e) {
    e.preventDefault();
    const modal = e.target.closest("info-modal");
    const input = modal.querySelector("input[type='email']");
    input.dispatchEvent(new Event("input"));

    if (modal.querySelector(".error-message")) return;

    e.target.classList.add("loading");
    const email = this.querySelector("#passwordEmail")?.value;

    await fetch(this.passwordRequestWorkflow.dataset.sendPasswordRequest, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
      }),
    })
      .then((res) => {
        console.log(res);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        e.target.classList.remove("loading");
        e.target.classList.add("loaded");
        input.value = "";
        setTimeout(() => {
          modal.close();
          e.target.classList.remove("loaded");
        }, 3000);
      });
  }
  createErrorMessage(el, message) {
    if (this.clearButtons.length)
      this.clearButtons.forEach((btn) => btn.classList.add("disabled"));

    const errorSpan = document.createElement("span");
    errorSpan.className = "error-message";
    errorSpan.innerHTML = message;
    const errorMessage = el.parentNode.querySelector(".error-message");

    if (errorMessage) {
      errorMessage.textContent = message;
    } else {
      el.parentNode.appendChild(errorSpan);
    }
  }
  removeErrorMessage(el) {
    if (this.clearButtons.length)
      this.clearButtons.forEach((btn) => btn.classList.remove("disabled"));

    const errorSpan = el.parentNode.querySelector(".error-message");
    if (errorSpan) errorSpan.remove();
  }
  textInputsValid(input) {
    if (input.value === "") {
      this.createErrorMessage(input, "Please fill in this field");
    } else if (
      input.dataset.typeEmail === "employee" &&
      input.value.substring(0, 2) !== "03"
    ) {
      this.createErrorMessage(input, "Incorrect tel must start with a “03”");
    } else if (
      input.dataset.typeEmail === "family-friends" &&
      input.value.substring(0, 2) !== "FF"
    ) {
      this.createErrorMessage(input, "Incorrect tel must start with a “FF”");
    } else if (
      input.dataset.typeEmail === "employee" &&
      input.value.length < 8
    ) {
      this.createErrorMessage(input, "Incorrect tel must be 8 digits long");
    } else if (input.dataset.firstName) {
      this.name = input.value.toLowerCase().trim();
      this.removeErrorMessage(input);
    } else if (input.dataset.lastName) {
      this.surname = input.value.toLowerCase().trim();
      this.removeErrorMessage(input);
    } else if (input.dataset.address1) {
      this.address1 = input.value.toLowerCase().replaceAll(",", "").trim();
      this.removeErrorMessage(input);
    } else if (input.dataset.address2) {
      this.address2 = input.value.toLowerCase().replaceAll(",", "").trim();
      this.removeErrorMessage(input);
    } else {
      this.removeErrorMessage(input);
    }
  }
  emailInputsValid(input) {
    this.sendNotificationFlag = false;
    if (input.value === "") {
      this.createErrorMessage(input, "Please fill in this field");
    } else if (!input.value.includes("@") || !input.value.includes(".")) {
      this.createErrorMessage(input, "Incorrect email");
    } else if (
      this.settings &&
      this.settings.emailsBlock.some(
        (email) => email.toLowerCase() === input.value.toLowerCase()
      )
    ) {
      this.sendNotificationFlag = input.value;
    } else {
      this.removeErrorMessage(input);
    }
  }
  passwordInputsValid(input) {
    if (input.hasAttribute("data-origin-pass")) {
      this.originPass = input.value;
    }
    if (input.hasAttribute("data-confirm-pass")) {
      this.confirmPass = input.value;
    }

    if (input.value === "") {
      this.createErrorMessage(input, "Please fill in this field");
    } else if (input.value.length < 8) {
      this.createErrorMessage(input, "Minimum number of characters - 8");
    } else if (!/\d/.test(input.value)) {
      this.createErrorMessage(
        input,
        "Use a combination of words and numbers for a stronger password"
      );
    } else if (
      this.originPass !== this.confirmPass &&
      input.hasAttribute("data-confirm-pass")
    ) {
      this.createErrorMessage(input, "Passwords do not match");
    } else {
      this.removeErrorMessage(input);
    }
  }
  checkboxInputsValid(input) {
    if (!input.checked) {
      this.createErrorMessage(input, "Please checked checkbox");
    } else {
      this.removeErrorMessage(input);
    }
  }
  telInputsValid(input) {
    const telFilter = new RegExp("^[-/+/0-9]*$");
    if (input.value === "") {
      this.createErrorMessage(input, "Please fill in this field");
    } else if (
      input.dataset.typeEmail === "employee" &&
      input.value.substring(0, 2) !== "03"
    ) {
      this.createErrorMessage(input, "Incorrect tel must start with a “03”");
    } else if (
      input.dataset.typeEmail === "family-friends" &&
      input.value.substring(0, 2) !== "FF"
    ) {
      this.createErrorMessage(input, "Incorrect tel must start with a “FF”");
    } else if (
      input.dataset.typeEmail === "employee" &&
      input.value.length < 8
    ) {
      this.createErrorMessage(input, "Incorrect tel must be 8 digits long");
    } else if (input.dataset.phone) {
      this.phone = input.value.toLowerCase().trim();
      this.removeErrorMessage(input);
    } else {
      this.removeErrorMessage(input);
    }
    //Contractor password condition
    //   else if(input.dataset.typeEmail === 'contractor' && input.value.substring(0, 4) !== 'BURB'){
    //     this.createErrorMessage(input, "Incorrect tel must start with a “BURB”");
    // }
  }
  numberInputsValid(input) {
    if (input.value === "") {
      this.createErrorMessage(input, "Please fill in this field");
    } else {
      this.removeErrorMessage(input);
    }
  }
  blockedUserAuth() {
    if (
      this.sendNotificationFlag ||
      this.settings?.namesBlock?.includes(`${this.name} ${this.surname}`)
    ) {
      this.createErrorMessage(this.submitButton, "You do not have access");
      this.sendNotification(
        this.settings.adminEmail,
        this.sendNotificationFlag || `${this.name} ${this.surname}`,
        window.location.hostname
      );
    } else {
      this.removeErrorMessage(this.submitButton);
    }
  }
  blockedUserAddresses() {
    if (!this.settings?.blockedAddresses) return;
    if (
      this.settings.blockedAddresses.some(
        (address) =>
          address === this.address1 ||
          address === this.address2 ||
          address === `${this.address1} ${this.address2}` ||
          address === `${this.address2} ${this.address1}`
      )
    ) {
      this.createErrorMessage(this.submitButton, "This address cannot be used");
    }
  }
  blockedUserPhones() {
    if (!this.settings?.blockedPhones) return;
    if (this.settings.blockedPhones.some((phone) => phone === this.phone)) {
      this.createErrorMessage(this.submitButton, "This phone cannot be used");
    }
  }
  handleSubmit(e) {
    e.preventDefault();
    this.allRequiredInputs.forEach((input) => {
      input.dispatchEvent(new Event("input"));
    });
    this.blockedUserAuth();
    this.blockedUserAddresses();
    this.blockedUserPhones();

    if (new URLSearchParams(window.location.search).get("types")) {
      localStorage.setItem("authUrl", window.location.search);
    }
    if (e.target.dataset.typeForm) {
      localStorage.setItem(
        "authUrl",
        `types=${e.target.dataset.typeForm},login,recover&steps=second-step,third-step,fourth-step`
      );
    }
    if (
      !this.querySelector(".error-message") &&
      this.form.id !== "familyFriendForm"
    ) {
      this.submitButton.classList.add("loading");
      if (window?.Shopify?.captcha?.protect) {
        window.Shopify.captcha.protect(this.form, (e) => {
          this.form.submit();
        });
      } else {
        setTimeout(() => {
          this.form.submit();
        }, 100);
      }
    }
  }
  clearFields() {
    this.allInputs.forEach((input) => (input.value = ""));
    if (this.clearButtons.length)
      this.clearButtons.forEach((btn) => btn.classList.add("disabled"));
  }
}
customElements.define("validation-form", ValidationForm);
